'use strict'

const fetchConfig = {

    init(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
        };
    }
}

export default fetchConfig